import _ from 'underscore';
import $ from 'jquery';

export default class OfferRequests {
  constructor($scope, OfferRequestService, PaginationService, UserService) {
    function set_supplier_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Seller', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.supplier_id = ui.item.id;
          $scope.$apply();
        }
      });
    }

    function set_buyer_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.buyer_id = ui.item.id;
          $scope.$apply();
        }
      });
    }

    $scope.load_data = function() {
      $scope.loading = true;
      OfferRequestService.get($scope.filter).success(function(data) {
        _.each(data.offer_requests, function(r) {
          r.total_quantity = window.roundToTwo(_.reduce(_.pluck(r.items, 'quantity'), function(quantity, num) {
            return quantity + parseFloat(num);
          }, 0));
          r.selections_quantity = window.roundToTwo(_.reduce(_.pluck(_.filter(r.items, function(i) {
            return i.status < 2;
          }), 'quantity'), function(quantity, num) {
            return quantity + parseFloat(num);
          }, 0));
          r.reservations_quantity = window.roundToTwo(_.reduce(_.pluck(_.filter(r.items, function(i) {
            return i.status === 2;
          }), 'quantity'), function(quantity, num) {
            return quantity + parseFloat(num);
          }, 0));
          r.oc_total_quantity = window.roundToTwo(_.reduce(_.pluck(r.order_confirmations, 'quantity'), function(quantity, num) {
            return quantity + parseFloat(num);
          }, 0));
          _.each(r.order_confirmations, function(c) {
            c.quantity = parseFloat(c.quantity);
          });
        });
        $scope.offer_requests = data.offer_requests;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.loading = false;
      });
    };

    $scope.init_filters = function() {
      $scope.supplier_company = null;
      $scope.buyer_company = null;
      $scope.filter = {
        page: 1,
        supplier_id: null,
        buyer_id: null,
        status: 1,
        order_status: 0,
        pref_status: 0
      };
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.get_status_title = function(status) {
      return _.findWhere($scope.status_options, {
        id: status
      }).title;
    };

    $scope.delete = function(offer_request_id) {
      if (confirm('Are you sure you want to delete this offer request?')) {
        OfferRequestService.delete(offer_request_id).success(function(data) {
          if (data.success)
            $scope.load_data();
        });
      }
    };

    $scope.order_status_options = [
      {
        id: 0,
        title: 'No'
      },
      {
        id: 1,
        title: 'Yes'
      }
    ];

    $scope.pref_status_options = [
      {
        id: 0,
        title: 'All'
      },
      {
        id: 1,
        title: 'Yes'
      },
      {
        id: 2,
        title: 'No'
      }
    ];

    $scope.init = function() {
      $scope.offer_campaigns = [];
      $scope.pagination = {};
      $scope.status_options = OfferRequestService.get_status_options();
      set_supplier_company_autocomplete($('input.supplier_company'));
      set_buyer_company_autocomplete($('input.buyer_company'));
      $scope.init_filters();
      $scope.load_data();
    };

    $scope.init();
  }
}

OfferRequests.$inject = ['$scope', 'OfferRequestService', 'PaginationService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-requests.ctrl.js